import styled from 'styled-components'

export const MarkerWrapper = styled.div`
  display: flex;
  position: relative;

  > div {
    display: flex;
    position: absolute;
    transform: translate(-50%, -100%);
    svg:last-child {
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
    }
    .dailyrunner {
      width: 36px;
      height: 44px;
    }
  }

  .flag-icon {
    position: absolute;
    right: 5px;
    top: 7px;
  }
`

export const MapWrapper = styled.div`
  .map-frame {
    position: relative;

    width: 100%;
    // height: 100%;
    min-height: 350px;
  }

  .current-location {
    border-radius: 50%;
  }

  .control-panal {
    position: absolute;
    right: 10px;
    bottom: 20px;
  }

  .zoom-group-btn {
    display: 'flex';
    flex-direction: 'column';
  }

  .zoom-in-btn {
    border-bottom: 1px solid rgb(218, 218, 218);
    border-radius: 22px 22px 0px 0px;
  }

  .zoom-out-btn {
    margin-bottom: 8px;
    border-radius: 0px 0px 22px 22px;
  }

  .map-btn {
    width: 44px;
    height: 44px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 8px 0px;
    background-color: rgb(255, 255, 255);
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    // transition: all 150ms ease 0s;
    position: relative;
    transition: 300ms;
    z-index: 1;
    flex: 1;
  }
  .map-btn:active {
    transition: 300ms;
    transform: scale(0.85);
  }
`
